module.exports = __webpack_public_path__ + "static/media/EVENT_REPORT.64bd49b0.png";